import React from 'react';
import Header from './Header';
import Navbar from './Navbar';
import Footer from './Footer';
import CookieBanner from './CookieBanner';
import { useAuth } from '../contexts/AuthContext';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  const { logout, isContractor } = useAuth();

  return (
    <div className="app-layout">
      <Header onLogout={logout} />
      {/* Hide navigation for contractors - Laravel equivalent behavior */}
      {!isContractor() && <Navbar />}
      <main className="main-content">
        <Outlet />
        <Footer />
      </main>
      <CookieBanner />
    </div>
  );
};

export default Layout; 